import { SVGProps, Ref, forwardRef } from 'react';

export const MailBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M15.313 11.997a3.31 3.31 0 1 1-3.31-3.31c1.828 0 3.31 1.49 3.31 3.31M12.003 1C5.936 1 1 5.936 1 12.003S5.936 23 12.003 23c2.22 0 4.365-.662 6.198-1.917l.035-.02-1.482-1.724-.028.014a8.75 8.75 0 0 1-4.723 1.386c-4.819 0-8.742-3.923-8.742-8.743 0-4.819 3.923-8.742 8.742-8.742s8.743 3.923 8.743 8.743q0 .94-.207 1.882c-.276 1.137-1.069 1.482-1.669 1.434s-1.303-.476-1.31-1.524v-1.793a5.57 5.57 0 0 0-5.563-5.563 5.57 5.57 0 0 0-5.564 5.563 5.57 5.57 0 0 0 5.563 5.564c1.49 0 2.89-.586 3.944-1.64a3.58 3.58 0 0 0 2.751 1.64c.097.007.2.014.297.014.8 0 1.592-.269 2.233-.751.662-.504 1.152-1.228 1.42-2.096.042-.138.125-.462.125-.462v-.014A9.8 9.8 0 0 0 23 11.997C23.007 5.937 18.07 1 12.003 1"
                fill="#0077FF"
            />
        </g>
    </svg>
));
MailBrandSize24Glyph.displayName = 'MailBrandSize24Glyph';
